import { render, staticRenderFns } from "./TicketingForm.vue?vue&type=template&id=28a59c64&scoped=true&"
import script from "./TicketingForm.vue?vue&type=script&lang=js&"
export * from "./TicketingForm.vue?vue&type=script&lang=js&"
import style0 from "./TicketingForm.vue?vue&type=style&index=0&id=28a59c64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a59c64",
  null
  
)

export default component.exports